// A simple map to convert gender keys to display text
const GENDER_MAP = {
  male: 'Male',
  female: 'Female',
  'non-binary': 'Non-binary',
  prefer_not_to_say: 'Prefer not to say',
};

export const formatGender = (genderKey) => {
  return GENDER_MAP[genderKey] || 'Not set';
};

// Formats a 'YYYY-MM-DD' string into "Month Day, Year"
export const formatDate = (dateString) => {
  if (!dateString) return 'Not set';
  // Add a time to avoid timezone off-by-one errors
  const date = new Date(`${dateString}T12:00:00`);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
